import m from 'mithril'

export default m.trust(`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.6821 6.49139L7.50023 2L1.31836 6.49139L3.67962 13.7586H11.3208L13.6821 6.49139Z" fill="white" fill-opacity="0.2" stroke="white" stroke-opacity="0.6" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.4998 2L4.99982 8.5M13.6817 6.49139L4.99982 8.5M11.3204 13.7586L4.99982 8.5M3.6792 13.7586L4.99982 8.5" stroke="white" stroke-opacity="0.6" stroke-width="0.8" stroke-linejoin="round" stroke-dasharray="2 1"/>
</svg>
`)